// eslint-disable-next-line no-underscore-dangle
const runtime = (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) || {};

const getConfig = () => {
  return {
    api: {
      elkUrl: runtime.REACT_APP_ELK_URL ?? process.env.REACT_APP_ELK_URL, // api.elkUrl
      baseUrl: runtime.REACT_APP_BASE_URL ?? process.env.REACT_APP_BASE_URL, // api.baseUrl
      socketClientUrl: runtime.REACT_APP_SOCKET_CLIENT_URL ?? process.env.REACT_APP_SOCKET_CLIENT_URL, // ws.url
      oneSignalAppId: runtime.REACT_APP_ONE_SIGNAL_APP_ID ?? process.env.REACT_APP_ONE_SIGNAL_APP_ID, // onesignal.provider.appId
      timeout: 60000, //api.timeout
    },
    sendbird: {
      appId: runtime.REACT_APP_SENDBIRD_APP_ID ?? process.env.REACT_APP_SENDBIRD_APP_ID, // sendBird.applicationId
    },
    twilio: {
      phoneNumber: runtime.REACT_APP_TWILIO_PHONE_NUMBER ?? process.env.REACT_APP_TWILIO_PHONE_NUMBER, // twilio.voice.phoneNumber
    },
    opentok: {
      apiKey: runtime.REACT_APP_OPENTOK_API_KEY ?? process.env.REACT_APP_OPENTOK_API_KEY, // opentok.apiKey
    },
    mui: {
      licenseKey: runtime.REACT_APP_MUI_LICENSE_KEY ?? process.env.REACT_APP_MUI_LICENSE_KEY, // mui.licenseKey
    },
    stripe: {
      publicKey: runtime.REACT_APP_STRIPE_PUBLIC_KEY ?? process.env.REACT_APP_STRIPE_PUBLIC_KEY, // stripe.publishableKey
    },
    env: runtime.REACT_APP_ENV || process.env.REACT_APP_ENV || process.env.NODE_ENV || 'staging',
    contentful: {
      spaceId: runtime.REACT_APP_CONTENTFUL_SPACE_ID ?? process.env.REACT_APP_CONTENTFUL_SPACE_ID, // contentful.spaceId
      accessToken: runtime.REACT_APP_CONTENTFUL_ACCESS_TOKEN ?? process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN, // contentful.accessToken
    },
    gtm: {
      id: runtime.REACT_APP_GTM_ID ?? process.env.REACT_APP_GTM_ID, // gtm.id
    },
  };
};

export default getConfig();
